import { render } from "./hr-super-api.vue?vue&type=template&id=4ffbaf38&scoped=true"
import script from "./hr-super-api.vue?vue&type=script&lang=js"
export * from "./hr-super-api.vue?vue&type=script&lang=js"

import "./hr-super-api.vue?vue&type=style&index=0&id=4ffbaf38&scoped=true&lang=css"
import "./hr-super-api.vue?vue&type=style&index=1&id=4ffbaf38&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffbaf38"]])

export default __exports__